import { lazy } from 'react'
import { Navigate, Outlet, Route } from 'react-router-dom'
import { Layout } from './components/Layout'
import { RouteSuspense } from '@/components/RouteLoadingFallback'
import { PlaceholderPage } from './pages/PlaceholderPage'

const Dashboard = lazy(() =>
  import('@/apps/ekool-teacher/pages/Dashboard').then((m) => ({ default: m.Dashboard }))
)

const ClassDashboard = lazy(() =>
  import('@/apps/ekool-teacher/pages/ClassDashboard').then((m) => ({ default: m.ClassDashboard }))
)

const ClassAttendance = lazy(() =>
  import('@/apps/ekool-teacher/pages/ClassAttendance').then((m) => ({ default: m.ClassAttendance }))
)

const ClassNotes = lazy(() =>
  import('@/apps/ekool-teacher/pages/ClassNotes').then((m) => ({ default: m.ClassNotes }))
)

const ClassExcuses = lazy(() =>
  import('@/apps/ekool-teacher/pages/ClassExcuses').then((m) => ({ default: m.ClassExcuses }))
)

const ClassGrades = lazy(() =>
  import('@/apps/ekool-teacher/pages/ClassGrades').then((m) => ({ default: m.ClassGrades }))
)

const ClassStudents = lazy(() =>
  import('@/apps/ekool-teacher/pages/ClassStudents').then((m) => ({ default: m.ClassStudents }))
)

const ClassCalendar = lazy(() =>
  import('@/apps/ekool-teacher/pages/ClassCalendar').then((m) => ({ default: m.ClassCalendar }))
)

export const ekoolTeacherRouteBranch = (
  <Route path="ekool-teacher" element={<Layout />}>
    <Route index element={<Navigate to="teacher/dashboard" replace />} />

    {/* Subject teacher routes — /ekool-teacher/teacher/ */}
    <Route path="teacher" element={<Outlet />}>
      <Route index element={<Navigate to="dashboard" replace />} />
      <Route
        path="dashboard"
        element={
          <RouteSuspense>
            <Dashboard />
          </RouteSuspense>
        }
      />
      <Route path="journal" element={<PlaceholderPage titleKey="ekoolTeacher.nav.journal" />} />
      <Route path="calendar" element={<PlaceholderPage titleKey="ekoolTeacher.nav.calendar" />} />
      <Route path="reports" element={<PlaceholderPage titleKey="ekoolTeacher.nav.reports" />} />
      <Route path="materials" element={<PlaceholderPage titleKey="ekoolTeacher.nav.materials" />} />
      <Route path="formative" element={<PlaceholderPage titleKey="ekoolTeacher.nav.formative" />} />
      <Route path="outcomes" element={<PlaceholderPage titleKey="ekoolTeacher.nav.outcomes" />} />
      <Route path="courses" element={<PlaceholderPage titleKey="ekoolTeacher.nav.courses" />} />
    </Route>

    {/* Class teacher routes — /ekool-teacher/class/ */}
    <Route path="class" element={<Outlet />}>
      <Route index element={<Navigate to="dashboard" replace />} />
      <Route
        path="dashboard"
        element={
          <RouteSuspense>
            <ClassDashboard />
          </RouteSuspense>
        }
      />
      <Route
        path="calendar"
        element={
          <RouteSuspense>
            <ClassCalendar />
          </RouteSuspense>
        }
      />
      <Route
        path="attendance"
        element={
          <RouteSuspense>
            <ClassAttendance />
          </RouteSuspense>
        }
      />
      <Route
        path="notes"
        element={
          <RouteSuspense>
            <ClassNotes />
          </RouteSuspense>
        }
      />
      <Route
        path="absence-notes"
        element={
          <RouteSuspense>
            <ClassExcuses />
          </RouteSuspense>
        }
      />
      <Route
        path="grades"
        element={
          <RouteSuspense>
            <ClassGrades />
          </RouteSuspense>
        }
      />
      <Route
        path="students"
        element={
          <RouteSuspense>
            <ClassStudents />
          </RouteSuspense>
        }
      />
    </Route>
    {/* Shared routes — available in both roles */}
    <Route path="messages" element={<PlaceholderPage titleKey="ekoolTeacher.messaging" />} />
    <Route path="account" element={<PlaceholderPage titleKey="ekoolTeacher.accountSettings" />} />
  </Route>
)
